export const cellPadding = '16px 12px 16px 16px';
export const compactPadding = '5px 15px';
export const superCompactPadding = '5px';
